import React from 'react'
import Fab from "@material-ui/core/Fab";
import AddIcon from "@mui/icons-material/Add";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { Link } from "react-router-dom";
import "./FloatingButton.css";

const FloatingButton = (props) => {
  return (
    <div className={props.icon === "back" ?  "fab-left" : "fab-right"}>
        
        <Link to={props.icon === "back" ?   "/" : props.route }>
          <Fab size="large" style={{ backgroundColor: "#bdd5ea" }} aria-label="add">
            {props.icon === "back" ? <ArrowBackIcon />: <AddIcon />  }
          </Fab>
        </Link>
     </div>
  )
}
export default FloatingButton;